import './Tag';



// WEBPACK FOOTER //
// ../../~/tslint-loader!./packages/tag/index.ts